import { Component, inject, signal } from '@angular/core'
import { FooterComponent } from '../../ui/footer/footer.component'
import { Router, RouterOutlet } from '@angular/router'
import { HeaderComponent } from '../../ui/header/header.component'
import { AuthDomain } from '../../../shared/domain/auth.domain'
import { logoUrl } from '../../data-access/constant/layout.constant'
import { Observable } from 'rxjs'
import { AsyncPipe } from '@angular/common'
import { MenuComponent } from '../../ui/menu/menu.component'
import { VersionDomain } from '../../domain/version.domain'
import { User } from '../../../shared/models/user'
import { UserDomain } from '../../../shared/domain/user.domain'
// eslint-disable-next-line @softarc/sheriff/dependency-rule
import { HomeDomain } from '../../../home/domain/home.domain'
import { Chantier } from '../../../shared/models/chantier'

@Component({
  selector: 'lg-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss'],
  imports: [HeaderComponent, RouterOutlet, FooterComponent, AsyncPipe, MenuComponent],
})
export class AppLayoutComponent {
  protected readonly logoUrl = logoUrl
  protected readonly backendVersion$: Observable<string>
  protected readonly connectedUser$: Observable<User>
  protected readonly selectableUserChantiers$: Observable<Chantier[]>
  protected readonly selectedChantier$: Observable<Chantier>
  protected readonly sidebarCollapsed = signal(true)
  private readonly authDomain
  private readonly versionDomain = inject(VersionDomain)
  private readonly userDomain = inject(UserDomain)
  private readonly router = inject(Router)
  private readonly homeDomain = inject(HomeDomain)

  constructor() {
    this.authDomain = inject(AuthDomain)
    this.backendVersion$ = this.versionDomain.getBackendVersion()

    if (!this.userDomain.connectedUser()) {
      this.userDomain.loadConnectedUser().subscribe()
    }
    this.connectedUser$ = this.userDomain.connectedUser$

    this.selectedChantier$ = this.homeDomain.selectedChantier$
    this.selectableUserChantiers$ = this.homeDomain.selectableUserChantiers$
  }

  toggleSidebar(): void {
    this.sidebarCollapsed.set(!this.sidebarCollapsed())
  }

  logOut(): void {
    this.authDomain.logOut()
  }

  onChantierSelected(chantierCode: string): void {
    this.router.navigate(['chantiers', chantierCode])
  }
}
